import { call, put, takeLatest } from "redux-saga/effects"

import { generateTree } from "utils/utils"

import { GET_DIMENSIONS_WATCHER } from "./constants"
import { getDimensionsSuccess, getDimensionsFailed } from "./actions"
import { getQuestionsApi } from "../../../utils/routes/routes-report"

export function* getDimensionsSaga(action) {
  try {
    const dataStatus = action.payload
    const questionsResponse = yield call(getQuestionsApi, dataStatus)
    let questions = questionsResponse ? questionsResponse.data : []

    const dimensionsSource = dataStatus.dimensions || {}
    const dimensions = dimensionsSource.data || []
    const metricTotal = dimensionsSource.metric_total
    const showDimensionBenchmark = dimensionsSource.show_dimension_benchmark

    if (questions && !Array.isArray(questions)) {
      questions = []
    }

    if (Array.isArray(questions) && questions.length > 0 && questions.error != "No data") {
      questions.map((e) => {
        e.id = parseInt(
          e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
        )
      })
    } else {
      questions = []
    }

    let dimensionsCopy = Array.isArray(dimensions) ? dimensions : []
    if (dimensionsCopy.error === "No data") {
      dimensionsCopy = []
    }

    const result = {}
    result.metric_total = metricTotal
    result.divisions = []
    result.show_dimension_benchmark = showDimensionBenchmark
    result.dimensions_drill_down = generateTree("id", "id_parent", [
      ...JSON.parse(JSON.stringify(dimensionsCopy)),
      ...JSON.parse(JSON.stringify(questions)),
    ])
    if (dataStatus.is_engagement) {
      result.metric_total.name = "Resultado total"
      result.metric_total.first = true
      result.dimensions_drill_down.unshift(result.metric_total)
    }

    yield put(getDimensionsSuccess(result))
  } catch (e) {
    yield put(getDimensionsFailed())
  }
}

export default function* widgetResultByDimensionEngagementSaga() {
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
}
